<web-settings-body *ngIf="extendedWidgetParams?.hasSetting">
    <web-control-resolver
        [widget]="widget"
        [isSpecific]="isSpecificWidget$ | async"
        [isEduSite]="isEduSite$ | async"
    ></web-control-resolver>
</web-settings-body>
